import ConversationType from 'owa-service/lib/contract/ConversationType';
import { SearchResultConversation } from 'mini-3s-service/lib/schema/SubstrateSearchResponse';
import {
    convertRecipientToSingleRecipientType,
    convertSearchSortOrder,
    convertToFolderId,
    convertToItemId,
    convertToItemIds,
    convertUtcDateTimeToRequestTimeZone,
} from './converterHelpers';

/**
 * Source : https://outlookweb.visualstudio.com/Outlook%20Web/_git/client-web?path=%2Fpackages%2Fcommon%2Fcontrols%2Fpackages%2Fcontrols%2Fsearch%2Fowa-search-service%2Flib%2Fhelpers%2FsubstrateTransformations%2Fresponse%2FconvertSearchResultConversationToConversationType.ts
 */

/**
 * Maps 3s results Conversation to ConversationType from owa-service
 * @param searchResultsConversation
 * @param requestTimeZone
 */
export function mapSearchResultConversationToConversationType(
    searchResultsConversation: SearchResultConversation,
    requestTimeZone: string
): ConversationType {
    const {
        Categories,
        ConversationId,
        ConversationTopic,
        FlagStatus,
        ParentFolderId,
        FolderRefinerId,
        From,
        GlobalItemIds,
        GlobalMessageCount,
        GlobalUnreadCount,
        HasAttachments,
        Hashtags,
        HasIrm,
        Importance,
        ItemClasses,
        ItemIds,
        LastDeliveryOrRenewTime,
        LastDeliveryTime,
        LastModifiedTime,
        MailboxGuids,
        MessageCount,
        Preview,
        SenderSMTPAddress,
        SortOrderSource,
        UniqueRecipients,
        UniqueSenders,
        UnreadCount,
    } = searchResultsConversation;

    return {
        Categories,
        ConversationId: convertToItemId(ConversationId),
        ConversationTopic,
        FlagStatus,
        FolderId: convertToFolderId(ParentFolderId),
        FolderRefinerId,
        From: convertRecipientToSingleRecipientType(From),
        GlobalItemIds: convertToItemIds(GlobalItemIds),
        GlobalMessageCount,
        GlobalUnreadCount,
        HasAttachments,
        Hashtags,
        HasIrm,
        Importance,
        ItemClasses,
        ItemIds: convertToItemIds(ItemIds),
        LastDeliveryOrRenewTime: convertUtcDateTimeToRequestTimeZone(
            LastDeliveryOrRenewTime,
            requestTimeZone
        ),
        LastDeliveryTime: convertUtcDateTimeToRequestTimeZone(LastDeliveryTime, requestTimeZone),
        LastModifiedTime: convertUtcDateTimeToRequestTimeZone(LastModifiedTime, requestTimeZone),
        MailboxGuids,
        MessageCount,
        ParentFolderId: convertToFolderId(ParentFolderId),
        Preview,
        SenderSMTPAddress,
        SortOrderSource: convertSearchSortOrder(SortOrderSource),
        UniqueRecipients,
        UniqueSenders,
        UnreadCount,
    };
}
